<template lang="pug">
  div
    v-btn(small, class="map-floating-button", @click="searchByAddress")
      v-icon location_searching
    div(:id="mapId", class="map")
</template>

<style lang="postcss" scoped>
  button.map-floating-button {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
    margin-left: 200px;
  }
  .map {
    height: 600px;
  }
</style>

<script>
/* globals google */
const googleMapsAPIAddress = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDmN_CGDx1du8dMjNiAUmG06-CDugqLLgI';
const mapId = `map-coordinates-picker-${new Date().getTime()}`;

export default {
  props: ['o-lat', 'o-lng', 'geo-address'],
  data() {
    return {
      mapId,
      map: null,
      marker: null,
      geocoder: null,
      lat: 40.460000,
      lng: -3.750000,
      zoom: 6,
    };
  },
  mounted() {
    const mapScriptElementId = 'googleMapsAPI';

    if (this.oLat && this.oLng) {
      this.lat = parseFloat(this.oLat);
      this.lng = parseFloat(this.oLng);
      this.zoom = 15;
    }

    if (document.body.querySelector(`#${mapScriptElementId}`) === null) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = mapScriptElementId;
      script.src = googleMapsAPIAddress;
      script.onload = this.initMap;
      document.body.appendChild(script);
    } else {
      this.initMap();
    }
  },
  methods: {
    getLatLng() {
      return { lat: this.lat, lng: this.lng };
    },
    initMap() {
      this.map = new google.maps.Map(document.getElementById(this.mapId), {
        center: this.getLatLng(),
        zoom: this.zoom,
      });

      this.marker = new google.maps.Marker({
        position: this.getLatLng(),
        draggable: true,
        map: this.map,
      });

      this.geocoder = new google.maps.Geocoder();

      this.marker.addListener('dragend', this.handleDragMarker);
    },
    handleDragMarker() {
      this.lat = this.marker.position.lat();
      this.lng = this.marker.position.lng();
      this.map.setCenter(this.marker.position);
      this.$emit('change', this.lat, this.lng);
    },
    searchByAddress() {
      const address = this.geoAddress;
      this.geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK') {
          this.marker.setPosition(results[0].geometry.location);
          this.handleDragMarker();
        } else {
          // eslint-disable-next-line
          console.error(`Geocode was not successful for the following reason: ${status}`);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CoordinatesPicker.vue